import { SVGProps } from 'react'

export const SpiralSelectorArrowIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="33rem"
      height="14rem"
      viewBox="0 0 33 14"
      fill="none"
      {...props}
    >
      <path
        d="M2 7.01342C4.82873 5.63105 6.15236 4.27402 8.10581 1M2 7.01342C4.54069 8.2093 5.87835 9.44734 8.10581 13M2 7.01342L55 7.01342"
        stroke="url(#paint0_linear_1544_7005)"
        strokeWidth="1.5"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1544_7005"
          x1="2"
          y1="7"
          x2="45.5"
          y2="6.99999"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D3D3D3" />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  )
}
